import { colorsPalettes } from "@similarweb/styles";
import { Button, IconButton } from "@similarweb/ui-components";
import { AssetsService } from "app/services/AssetsService";
import styled from "styled-components";
import { Spinner } from "pro-features/components/Loaders/src/Spinner";
import { setFont } from "@similarweb/styles";

const { carbon, bluegrey, red, sky, navigation, blue } = colorsPalettes;

export const ModalTitle = styled.div`
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${setFont({ $color: carbon[500], $weight: 500, $size: 20, $family: "DM Sans" })};
`;

export const ModalFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;

export const SectionTitle = styled.div`
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    color: ${carbon[400]};
    margin: 12px 0;
`;

export const SectionBody = styled.div`
    font-size: 14px;
    line-height: 20px;
    color: ${carbon[500]};
    margin-bottom: 12px;

    a {
        font-weight: bold;
        cursor: pointer;
        white-space: nowrap;

        .SWReactIcons {
            display: inline-block;
            vertical-align: baseline;

            svg {
                margin-bottom: -2px;
                &,
                & path {
                    fill: ${blue[400]};
                }
            }
        }
    }
`;

export const ImportIconButton = styled(IconButton)`
    margin-top: 12px;

    .SWReactIcons {
        transform: rotate(180deg);
    }
`;

export const CancelButton = styled(Button).attrs((props) => ({ type: "flat" }))`
    margin-top: 12px;
    margin-right: 8px;
`;

export const UploadedFileBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border: 1px solid ${navigation["ICON_BAR_BACKGROUND"]};
    border-radius: 2px;
    padding: 12px;

    a {
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }
`;

export const UploadedFileName = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    line-height: 18px;
    color: ${carbon[300]};

    .SWReactIcons {
        margin-right: 0.7em;
        vertical-align: baseline;
        width: 1.5em;
        height: 1.5em;
    }
`;

export const UploadedFileStats = styled.div`
    font-size: 12px;
    line-height: 16px;
    color: ${carbon[300]};
    padding: 6px 4px;
    margin-bottom: 20px;
    .SWReactIcons {
        display: inline-block;
        margin-right: 0.7em;
        vertical-align: baseline;
        width: 0.8em;
        height: 0.8em;

        svg {
            &,
            & path {
                fill: ${carbon[300]};
            }
        }
    }
`;

const CSVFileSuccessImage = styled.div`
    width: 120px;
    height: 144px;
    margin: 18px auto;
    margin-bottom: 10px;
    background: url(${AssetsService.assetUrl("/images/file-success.svg")}) top center no-repeat;
    background-size: contain;
`;

export const CSVFileDropZoneContainer = styled.div`
    margin: 24px 0;
`;

export const CSVFileDropZoneBoxContainer = styled.div<{
    isOver: boolean;
    isProcessing: boolean;
    isError: boolean;
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
    min-height: 120px;
    border-radius: 2px;
    border: 1px dashed ${({ isProcessing, isError }) => (isProcessing ? carbon[200] : isError ? red["s100"] : sky[500])};
    background: ${({ isOver, isProcessing }) => (isProcessing ? carbon[25] : isOver ? sky[100] : bluegrey[100])};
    transition: background 0.2s;
`;

export const CSVFileDropZoneText = styled.div`
    font-size: 14px;
    line-height: 20px;

    a {
        font-weight: bold;
        cursor: pointer;
        white-space: nowrap;
    }
`;

export const CSVFileDropZoneImage = styled.div`
    width: 65px;
    height: 65px;
    margin: 0 auto;
    background: url(${AssetsService.assetUrl("/images/upload-cloud.svg")}) top center no-repeat;
`;

export const ProcessingSpinner = styled(Spinner)`
    display: inline-block;
    vertical-align: baseline;
    margin-right: 0.5em;
    width: 0.8em;
    height: 0.8em;
`;

export const ErrorMessage = styled.div`
    font-size: 12px;
    line-height: 16px;
    color: ${red[400]};
`;
